import React from 'react';
import { motion } from 'framer-motion';
import { staggerContainer, staggerItem } from '../../utils/animations';
import Section from '../../Components/common/Section';
import TestimonialCard from '../../Components/common/TestimonialCard';
import GradientText from '../../Components/common/GradientText';

const TestimonialsSection = () => {
  const testimonials = [
    {
      quote: 'RuhiTech built our entire operations dashboard from scratch. The team understood our workflow perfectly and delivered a clean, reliable product on time.',
      name: 'Karthik Suresh',
      role: 'Business Owner',
    },
    {
      quote: 'We needed an automation solution to handle our billing and reporting. RuhiTech delivered exactly what we needed and it saves us hours every week.',
      name: 'Meera Nair',
      role: 'Operations Manager',
    },
    {
      quote: 'The web application they developed for us is fast, easy to use, and has held up perfectly under load. Great team to work with.',
      name: 'Arjun Patel',
      role: 'Founder',
    },
  ];

  return (
    <Section background="white">
      <motion.div
        variants={staggerContainer}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.2 }}
      >
        <motion.div variants={staggerItem} className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            What Our <GradientText>Clients Say</GradientText>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it - hear from our satisfied clients
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div key={index} variants={staggerItem}>
              <TestimonialCard {...testimonial} />
            </motion.div>
          ))}
        </div>
      </motion.div>
    </Section>
  );
};

export default TestimonialsSection;
